import React from 'react';
import styled from 'styled-components';

import ICONS from 'components/Icons';
import { SCREEN } from 'scenes/common/types/screen';

const UnknownImage = styled.img`
  height: 5rem;
  width: 100%;
  position: relative;
  z-index: 2;
  top: 25px;

  @media (min-width: ${SCREEN.SMALL}px) {
    height: 238px;
    width: 575px;
    top: 40px;
  }
`;

export const Unknown = () => (
  <UnknownImage
    src={ICONS.ERROR.HOME.UNKNOWN}
    tabIndex={-1}
    alt="Building roof flying graphic"
  />
);

export default Unknown;
